import { Injectable } from '@angular/core'
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr'
import { Observable, Subject } from 'rxjs'
import { Import, ImportDto, importFromDto } from '../models/import.model'
import { BaseService } from './base.service'

@Injectable({
    providedIn: 'root'
})
export class SignalrService extends BaseService {
    private hubConnection!: HubConnection
    private importStatus$$: Subject<Import> = new Subject<Import>()

    readonly importStatus$: Observable<Import> = this.importStatus$$.asObservable()

    startConnection(): Promise<void> {
        this.hubConnection = new HubConnectionBuilder().withUrl('/api/signalr').build()

        return this.hubConnection.start()
    }

    listenToAllFeeds(): void {
        this.hubConnection.on('SendImportStatusAsync', (data: ImportDto) => {
            const model = importFromDto(data)
            this.importStatus$$.next(model)
        })
    }
}
